import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import React from "react";
import styled from "styled-components";
import ProceduresManualContext from "./ProceduresManualContext";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {
  Switch
} from "@material-ui/core";
// import Switch from "react-switch";

const Title = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;

  text-align: left;

  @media (max-width: 300px) {
    font-size: 8px;
    font-weight: 500;  
  };

  @media  (min-width:401px) {
    font-size: 10px;
    font-weight: 500;  
  };

  @media (min-width:700px) {
    font-size: 12px;
    font-weight: 500;  
  };

  @media  (min-width:1001px) {
    font-size: 15px;
    font-weight: 500;  
  };

  @media  (min-width:1201px) {
    font-size: 20px;
    font-weight: 500;  
  };

`;

const SubTitle = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.25px;
  text-align: left;
`;

const TitleContainer = styled.div`
  padding-left:20px;
  max-height:56px;
`;

const Container = styled.div`
`;

const FunctionContainer = styled.div`
  background-color: #304a57;
  width: 100%;
  color:white;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  padding:10px;
  padding-left:10px;
  display:flex;
  align-items:center;
  justify-content:space-between;
`;

const ProjectContainer = styled.div`
  display: grid;
  align-items: center;
  padding-top:20px;
  // grid-template-columns: auto 71px minmax(200px,500px) minmax(80px,200px);
  grid-template-columns: auto 158px minmax(200px,523px) minmax(80px,202px);
  padding-bottom:10px;
`;

const ManualCommentContainer = styled.div`
  // display: grid;
  align-items: center;
  padding-left:20px;
  padding-right: 20px;
  // grid-template-columns:auto 20px minmax(200px,400px) minmax(80px,200px);
  padding-bottom:10px;
`;

const SDNContainer = styled.div`
  padding-right: 20px;
`;

const RevContainer = styled.div`
  padding-right: 20px;
`;


class ProcedureManualHeader extends React.Component {
  static contextType = ProceduresManualContext;

  state = {
    checkedSwitch: true,
  }

  handleChange = () => {
    this.setState({ checkedSwitch: !this.state.checkedSwitch })
  }


  componentDidMount() {
    this.context.updateSdnFormValue(this.context.procedureManual.header.sdn);
    this.context.updateSdnRevFormValue(this.context.procedureManual.header.rev);
    this.context.updateSdnCommentFormValue(this.context.procedureManual.header.comment);
  }
  render() {
    const { gbuName, projectName, functionName } = this.context.procedureManual
      .header
      ? this.context.procedureManual.header
      : {};

    const { actionGroupForDisplayedProcedureManual = {} } = this.context.procedureManual;

    const { readOnly } = actionGroupForDisplayedProcedureManual;

    return (
      <Container>
        <FunctionContainer>
          <div> {`${functionName} Procedures Manual`}</div>
          <IconButton
            color="inherit"
            onClick={() => this.context.hideProcedureManual()}
          >
            <CloseIcon />
          </IconButton>
        </FunctionContainer>
        <ProjectContainer>
          <TitleContainer>
            <Title>
              {projectName}
            </Title>
          </TitleContainer>
          <div>
            <Switch checked={this.state.checkedSwitch} onChange={this.handleChange} name="checked" />
          </div>
          {this.state.checkedSwitch && <SDNContainer>
            <TextField
              disabled={this.context.procedureManual.creatingProcedureManual || readOnly}
              fullWidth
              value={this.context.sdnFormValue}
              label="Procedure Manual SDN"
              variant="outlined"
              onChange={(event) =>
                this.context.updateSdnFormValue(event.target.value)
              }
            />
          </SDNContainer>}
          {this.state.checkedSwitch && <RevContainer>
            <TextField
              disabled={this.context.procedureManual.creatingProcedureManual || readOnly}
              fullWidth
              value={this.context.sdnRevFormValue}
              label="Manual Rev #"
              variant="outlined"
              onChange={(event) =>
                this.context.updateSdnRevFormValue(event.target.value)
              }
            />
          </RevContainer>}
        </ProjectContainer>
        {this.state.checkedSwitch && <ManualCommentContainer>
          <TextField
            disabled={this.context.procedureManual.creatingProcedureManual || readOnly}
            maxRows={2}
            minRows={2}
            multiline
            fullWidth
            value={this.context.sdnCommentFormValue}
            label="Procedure Manual Comments"
            variant="outlined"
            onChange={(event) =>
              this.context.updateSdnCommentFormValue(event.target.value)
            }
          />
        </ManualCommentContainer>}
        <Divider />
      </Container>
    );
  }
}

export default ProcedureManualHeader;
